import axios from 'axios'

export const axiosPublic = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  responseType: 'json',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})
